import { createSubTask as _createSubTask } from '@griply/services';
import { ID } from '@griply/types';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  Timestamp,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

import { getAuthentication, getDatabase } from './helpers';

export type CreateSubTaskInput = {
  name: string;
  parentId: ID;
  parentParentIds: ID[] | null;
  parentChildIds: ID[] | null;
};

export const createSubTask = async ({
  name,
  parentId,
  parentParentIds,
  parentChildIds,
}: CreateSubTaskInput): Promise<{
  id: ID;
  parentIds: ID[];
  name: string;
} | null> => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const db = getDatabase();

  return _createSubTask({
    name,
    parentId,
    parentParentIds,
    parentChildIds,
    userId: user.uid,
    collection,
    doc,
    db,
    serverTimestamp,
    timestampFromDate: Timestamp.fromDate,
    writeBatch: (_db) => writeBatch(_db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.CreateSubTask,
        error,
        uid: user.uid,
      }),
  });
};
